import { Capacitor } from "@capacitor/core";

const HARMONY_UA_RE = /ArkWeb|HarmonyOS|OpenHarmony/i;

export function isHarmonyLikeWebView() {
    if (typeof window === "undefined" || typeof navigator === "undefined") return false;

    const ua = String(navigator.userAgent || "");
    const protocol = String(window.location?.protocol || "");
    const href = String(window.location?.href || "");

    return HARMONY_UA_RE.test(ua) || protocol === "resource:" || /rawfile\/www/i.test(href);
}

export function isCapacitorNativePlatform() {
    return !!Capacitor?.isNativePlatform?.();
}

export function isNativePlatform() {
    return isCapacitorNativePlatform() || isHarmonyLikeWebView();
}

export function getPlatform() {
    if (isCapacitorNativePlatform()) {
        return Capacitor.getPlatform?.() || "web";
    }

    if (isHarmonyLikeWebView()) {
        return "harmony";
    }

    return "web";
}

export function getPlatformLabel() {
    const platform = getPlatform();
    const labels = {
        ios: "iOS",
        android: "Android",
        harmony: "HarmonyOS",
        web: "Web (浏览器)",
    };

    return labels[platform] || platform;
}
